// This file is auto-generated by @hey-api/openapi-ts

import { z } from "zod/v3";

/**
 * CustomInputNumber
 */
export const zCustomInputNumber = z.object({
  type: z.literal("number").optional().default("number"),
  index: z.number().int(),
  key: z.string(),
  modelVersion: z.string(),
  label: z.string(),
  defaultValue: z.union([z.number(), z.number().int()]).nullish(),
  relativeTo: z.string().nullish(),
});

/**
 * CustomInputSelectOptional
 */
export const zCustomInputSelectOptional = z.object({
  label: z.string(),
  value: z.string(),
});

/**
 * CustomInputSelect
 */
export const zCustomInputSelect = z.object({
  type: z.literal("select").optional().default("select"),
  index: z.number().int(),
  key: z.string(),
  modelVersion: z.string(),
  label: z.string(),
  options: z.array(zCustomInputSelectOptional),
  defaultValue: z.string().nullish(),
});

/**
 * CustomInputsRequest
 */
export const zCustomInputsRequest = z.object({
  model_key: z.string().optional().default(""),
  config_file: z.string().optional().default("custom_inputs_cnc.yaml"),
});

/**
 * DistanceUnit
 */
export const zDistanceUnit = z.enum(["m", "mm", "inch"]);

/**
 * DrawingExtractionConfigurationProcesses
 */
export const zDrawingExtractionConfigurationProcesses = z.object({
  surface_treatments: z.array(z.string()).optional().default([]),
});

/**
 * DrawingExtractionVersion
 */
export const zDrawingExtractionVersion = z.object({
  pyplan_version: z.string().optional(),
  fabai_version: z.string().optional(),
  drawing_analysis_version: z.string().optional(),
});

/**
 * FoldProperties
 */
export const zFoldProperties = z.object({
  angle: z.number(),
  folding_length: z.number().nullish(),
  area: z.number().nullish(),
  arc: z.number().nullish(),
});

/**
 * FoldFeatures
 */
export const zFoldFeatures = z.object({
  type: z.literal("Folding").optional().default("Folding"),
  properties: zFoldProperties,
});

/**
 * GDT_TYPE
 */
export const zGdtType = z.enum([
  "position",
  "parallelism",
  "flatness",
  "perpendicularity",
  "concentricity",
  "total_runout",
  "cylindricity",
  "angularity",
  "roundness",
  "circular_runout",
  "symmetry",
  "profile_line",
  "profile_plane",
  "straightness",
]);

/**
 * GraphEdgeAttr
 */
export const zGraphEdgeAttr = z.object({
  length: z.array(z.tuple([z.number()])),
  curve_type: z.array(z.tuple([z.number()])),
  arc_angle: z.array(z.tuple([z.number()])),
  origin: z.array(z.tuple([z.number(), z.number(), z.number()])),
  end: z.array(z.tuple([z.number(), z.number(), z.number()])),
});

/**
 * GraphEdgeIndex
 */
export const zGraphEdgeIndex = z.object({
  edge_index: z.tuple([z.array(z.number().int().gte(0)), z.array(z.number().int().gte(0))]),
});

/**
 * GraphGlobttr
 */
export const zGraphGlobttr = z.object({
  num_faces: z.tuple([z.number().int().gt(0)]),
  num_edges: z.tuple([z.number().int().gt(0)]),
  num_shapes: z.tuple([z.number().int().gt(0)]),
  frac_plane_faces: z.tuple([z.number()]),
  frac_cylinder_faces: z.tuple([z.number()]),
  frac_torus_faces: z.tuple([z.number()]),
  frac_plane_area: z.tuple([z.number()]),
  frac_cylinder_area: z.tuple([z.number()]),
  frac_torus_area: z.tuple([z.number()]),
  thickness: z.tuple([z.number()]),
  volume: z.tuple([z.number()]),
  area: z.tuple([z.number()]),
  dimensions: z.tuple([z.number(), z.number(), z.number()]),
});

/**
 * GraphOthers
 */
export const zGraphOthers = z.object({
  node_id: z.array(z.tuple([z.number().int().gte(0)])),
  node_face_id: z.array(z.tuple([z.number().int().gte(0)])),
  edge_id: z.array(z.tuple([z.number().int().gte(0)])),
});

/**
 * GraphPos
 */
export const zGraphPos = z.object({
  pos: z.array(z.tuple([z.number(), z.number(), z.number()])),
});

/**
 * GraphVersion
 */
export const zGraphVersion = z.object({
  fabai_version: z.string().optional(),
  graph_version: z.string().optional(),
});

/**
 * GraphX
 */
export const zGraphX = z.object({
  area: z.array(z.tuple([z.number()])),
  surface_type: z.array(z.tuple([z.number()])),
  curvature: z.array(z.tuple([z.number(), z.number(), z.number(), z.number()])),
  normal: z.array(z.tuple([z.number(), z.number(), z.number()])),
  degree: z.array(z.tuple([z.number().int().gte(0)])),
});

/**
 * Graph
 */
export const zGraph = z.object({
  x: zGraphX,
  pos: zGraphPos,
  edge_index: zGraphEdgeIndex,
  edge_attr: zGraphEdgeAttr,
  glob_attr: zGraphGlobttr,
  others: zGraphOthers,
  version: zGraphVersion.optional().default({ fabai_version: "0.0.0", graph_version: "0.0.0" }),
});

/**
 * HealthResponse
 */
export const zHealthResponse = z.object({
  status: z.string(),
  version: z.string(),
});

/**
 * HoleType
 */
export const zHoleType = z.enum(["hole_circular", "hole_complex", "hole_slotted", "hole_folded"]);

/**
 * HoleProperties
 */
export const zHoleProperties = z.object({
  hole_type: zHoleType,
  edge_length: z.number().nullish(),
  area: z.number().nullish(),
  is_through: z.boolean().nullish(),
  diameter: z.number().nullish(),
});

/**
 * HoleFeatures
 */
export const zHoleFeatures = z.object({
  type: z.literal("Hole").optional().default("Hole"),
  properties: zHoleProperties,
});

/**
 * HollowSquareBar
 *
 * Hollow square bar stock
 */
export const zHollowSquareBar = z.object({
  raw_type: z.literal("hollow_square").optional().default("hollow_square"),
  width: z.number().gte(0),
  height: z.number().gte(0),
  length: z.number().gte(0),
  thickness: z.number().gte(0),
});

/**
 * HollowTube
 *
 * Hollow tube stock
 */
export const zHollowTube = z.object({
  raw_type: z.literal("hollow_tube").optional().default("hollow_tube"),
  outer_diameter: z.number().gte(0),
  length: z.number().gte(0),
  thickness: z.number().gte(0),
});

/**
 * IndustrialProcess
 */
export const zIndustrialProcess = z.enum([
  "ASSEMBLING",
  "BENDING",
  "CHIMIC_ENGRAVING",
  "COMBINED_PUNCHING_LASER",
  "CONTROL",
  "COUNTERSINKING",
  "CRIMPING",
  "DEBURRING",
  "DRILLING",
  "ELECTRO_EROSION",
  "ENGRAVING",
  "FOLDING",
  "GRINDING",
  "HEAT_TREATMENT",
  "LASER_CUT",
  "MATERIAL",
  "MILLING",
  "OTHER",
  "OUTSOURCING",
  "PACKING",
  "PLASMA_CUT",
  "PRESSING",
  "PRODUCTS",
  "PUNCHING",
  "RIVETING",
  "ROLLING",
  "SAWING",
  "SHEARING",
  "SIMPLE",
  "SURFACE_TREATMENT",
  "TAPPING",
  "TRANSPORT",
  "TRIMMING",
  "TURNING",
  "UNSTAPLING",
  "WATER_CUT",
  "WELDING",
]);

/**
 * InteractionsSourceTarget
 */
export const zInteractionsSourceTarget = z.object({
  source: z.number().int(),
  target: z.number().int(),
  contact_length: z.number(),
});

/**
 * InteractionsProperties
 */
export const zInteractionsProperties = z.object({
  contact_length: z.number().nullish(),
  contact_length_details: z.array(zInteractionsSourceTarget),
});

/**
 * InteractionsFeatures
 */
export const zInteractionsFeatures = z.object({
  type: z.literal("Interactions").optional().default("Interactions"),
  properties: zInteractionsProperties,
});

/**
 * LLMStats
 */
export const zLlmStats = z.object({
  input_tokens: z.number().int().optional().default(0),
  output_tokens: z.number().int().optional().default(0),
  total_tokens: z.number().int().optional().default(0),
  total_cost: z.number().optional().default(0),
  duration: z.number().optional().default(0),
});

/**
 * DrawingExtractionModel
 */
export const zDrawingExtractionModel = z.object({
  material_description: z.string().nullish(),
  material_grade: z.string().nullish(),
  weight: z.number().nullish(),
  configuration_processes: zDrawingExtractionConfigurationProcesses
    .optional()
    .default({ surface_treatments: [] }),
  part_type: z.string().nullish(),
  general_tolerance: z.string().nullish(),
  general_roughness: z.number().nullish(),
  finest_roughness: z.number().nullish(),
  length: z.number().nullish(),
  width: z.number().nullish(),
  height: z.number().nullish(),
  volume: z.number().nullish(),
  manufacturing_process: z.string().nullish(),
  nb_drillings: z.number().int().nullish(),
  number_of_views: z.number().int().nullish(),
  model_processes: z.array(z.string()).optional(),
  finest_tolerance: z.number().nullish(),
  finest_tolerance_coverage: z.number().nullish(),
  finest_tolerance_bin_category: z.string().nullish(),
  additional_cost_drivers: z.record(z.unknown()).optional(),
  versions: zDrawingExtractionVersion.optional(),
  llm_stats: zLlmStats.optional(),
  debug: z.record(z.unknown()).optional(),
});

/**
 * MachiningProperties
 */
export const zMachiningProperties = z.object({
  area: z.number().nullish(),
});

/**
 * MachiningFeatures
 */
export const zMachiningFeatures = z.object({
  type: z.literal("Machining").optional().default("Machining"),
  properties: zMachiningProperties,
});

/**
 * MaterialGrade
 */
export const zMaterialGrade = z.enum([
  "ALUMINIUM",
  "BRASS",
  "COPPER",
  "GALVANIZED_STEEL",
  "STAINLESS_STEEL",
  "STEEL",
  "STEEL_PRE_LACQUERED",
  "STEEL_COLD_ROLLED_CORTEN",
  "STEEL_HOT_ROLLED_CORTEN",
  "ZINC",
  "BRONZE",
  "PLASTIC",
  "CAST_IRON",
  "RUBBER",
  "MAGNESIUM",
  "TITANIUM",
  "COMPOSITE",
  "WOOD",
  "INCONEL",
  "OTHER",
]);

/**
 * ModelAlias
 */
export const zModelAlias = z.enum(["prod", "dev"]);

/**
 * ModelVersionResponse
 */
export const zModelVersionResponse = z.object({
  model_key: z.string(),
  version_3d: z.string(),
  version_2d: z.string(),
});

/**
 * PartEmbeddings
 */
export const zPartEmbeddings = z.object({
  topological: z.array(z.number()).nullish(),
});

/**
 * PartGDT
 */
export const zPartGdt = z.object({
  type: zGdtType,
  tolerance: z.number().nullish(),
  datum: z.array(z.string()),
});

/**
 * PartLevel
 */
export const zPartLevel = z.enum(["PARENT", "CHILD", "ORPHELIN"]);

/**
 * PartRepresentation
 */
export const zPartRepresentation = z.object({
  graph: zGraph.nullish(),
  shape: z.unknown().nullish(),
  embeddings: zPartEmbeddings.nullish(),
});

/**
 * PartRoughness
 */
export const zPartRoughness = z.object({
  value: z.number(),
});

/**
 * PartTopoComplexity
 */
export const zPartTopoComplexity = z.object({
  n_faces: z.number().int().nullish(),
  n_edges: z.number().int().nullish(),
  n_plane_faces: z.number().int().nullish(),
  n_cylinder_faces: z.number().int().nullish(),
  n_torus_faces: z.number().int().nullish(),
});

/**
 * PartType
 */
export const zPartType = z.enum([
  "ASSEMBLY",
  "SHEET",
  "MACHINING",
  "ROUND_TUBE",
  "SQUARE_TUBE",
  "RECTANGULAR_TUBE",
  "ROUND_BAR",
  "SQUARE_BAR",
  "CONSUMABLE",
  "PROFILE",
  "OTHER",
]);

/**
 * PartMetadata
 */
export const zPartMetadata = z.object({
  files: z.array(z.string()).nullish(),
  material_description: z.string().nullish(),
  material_grade: zMaterialGrade.nullish(),
  material_density: z.number().nullish(),
  part_type: zPartType.nullish(),
  shape_name: z.string().nullish(),
  shape_nb: z.number().int().nullish(),
  group: z.number().int().nullish(),
  group_size: z.number().int().nullish(),
  weight: z.number().nullish(),
  weight_unit: z.enum(["g", "kg"]).nullish(),
  distance_unit: zDistanceUnit.nullish(),
  other_info: z.record(z.unknown()).nullish(),
});

/**
 * PartVersion
 */
export const zPartVersion = z.object({
  part_version: z.string(),
});

/**
 * PredictedProcessStep
 */
export const zPredictedProcessStep = z.object({
  description: z.string().nullish(),
  processKey: z.string().nullish(),
  industrialProcess: zIndustrialProcess,
  machinePreparationTime: z.number().nullish(),
  otherMachineTime: z.number().nullish(),
  machineHourlyRate: z.number().nullish(),
  machineHourlyPrice: z.number().nullish(),
  allowedForPartLevels: z.array(zPartLevel).optional().default([]),
  others: z.record(z.unknown()).nullish().default({}),
  alerts: z.record(z.unknown()).nullish().default({}),
  order: z.number().int().nullish(),
});

/**
 * PredictionErrorCode
 */
export const zPredictionErrorCode = z.enum(["missing", "value_error"]);

/**
 * PredictionInputErrorItem
 */
export const zPredictionInputErrorItem = z.object({
  code: zPredictionErrorCode,
  path: z.array(z.string()),
  message: z.string(),
});

/**
 * PredictionInputError
 */
export const zPredictionInputError = z.object({
  errors: z.array(zPredictionInputErrorItem),
});

/**
 * PredictionType
 *
 * Enum for value types.
 */
export const zPredictionType = z.enum(["price", "time"]);

/**
 * PredictionUnit
 *
 * Enum for value units.
 */
export const zPredictionUnit = z.enum(["minute", "hour", "second", "euro", "dollar"]);

/**
 * PredictedProcessStepsResponse
 */
export const zPredictedProcessStepsResponse = z.object({
  process_steps: z.array(zPredictedProcessStep).optional().default([]),
  prediction_type: zPredictionType,
  prediction_unit: zPredictionUnit,
  version: z.string(),
  errors: z.record(z.unknown()).nullish(),
});

/**
 * SideProperties
 */
export const zSideProperties = z.object({
  length: z.number(),
  area: z.number().nullish(),
  length_straight: z.number().nullish(),
  length_round: z.number().nullish(),
});

/**
 * SideFeatures
 */
export const zSideFeatures = z.object({
  type: z.literal("Side").optional().default("Side"),
  properties: zSideProperties,
});

/**
 * MultiModalUserInput
 */
export const zMultiModalUserInput = z.object({
  material_grade: zMaterialGrade.nullish(),
  material_description: z.string().nullish(),
  part_type: zPartType.nullish(),
  part_features: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("Hole"),
          })
          .and(zHoleFeatures),
        z
          .object({
            type: z.literal("Folding"),
          })
          .and(zFoldFeatures),
        z
          .object({
            type: z.literal("Side"),
          })
          .and(zSideFeatures),
        z
          .object({
            type: z.literal("Interactions"),
          })
          .and(zInteractionsFeatures),
        z
          .object({
            type: z.literal("Machining"),
          })
          .and(zMachiningFeatures),
      ]),
    )
    .nullish(),
});

/**
 * SolidRoundBar
 *
 * Solid round bar stock
 */
export const zSolidRoundBar = z.object({
  raw_type: z.literal("solid_round").optional().default("solid_round"),
  diameter: z.number().gte(0),
  length: z.number().gte(0),
});

/**
 * SolidSquareBar
 *
 * Solid square bar stock
 */
export const zSolidSquareBar = z.object({
  raw_type: z.literal("solid_square").optional().default("solid_square"),
  width: z.number().gte(0),
  height: z.number().gte(0),
  length: z.number().gte(0),
});

/**
 * BoundingBoxDimensions
 */
export const zBoundingBoxDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("bbox").optional().default("bbox"),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * RectangularTubeDimensions
 */
export const zRectangularTubeDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("rectangular_tube").optional().default("rectangular_tube"),
  thickness: z.number(),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * RoundBarDimensions
 */
export const zRoundBarDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("round_bar").optional().default("round_bar"),
  diameter: z.number(),
  length: z.number(),
});

/**
 * RoundTubeDimensions
 */
export const zRoundTubeDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("round_tube").optional().default("round_tube"),
  thickness: z.number(),
  diameter: z.number(),
  length: z.number(),
});

/**
 * SheetDimensions
 */
export const zSheetDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("sheet").optional().default("sheet"),
  thickness: z.number(),
  unfolded_width: z.number(),
  unfolded_length: z.number(),
});

/**
 * Source
 */
export const zSource = z.enum(["2d", "3d", "multi_modal"]);

/**
 * SquareBarDimensions
 */
export const zSquareBarDimensions = z.object({
  raw: z.union([zHollowSquareBar, zHollowTube, zSolidRoundBar, zSolidSquareBar]).nullish(),
  volume: z.number().nullish(),
  area: z.number().nullish(),
  section_area: z.number().nullish(),
  type: z.literal("square_bar").optional().default("square_bar"),
  width: z.number(),
  height: z.number(),
  length: z.number(),
});

/**
 * PartDimensions
 */
export const zPartDimensions = z.object({
  bbox: zBoundingBoxDimensions.nullish(),
  part: z
    .discriminatedUnion("type", [
      zSheetDimensions.extend({ type: z.literal("sheet") }),
      zSquareBarDimensions.extend({ type: z.literal("square_bar") }),
      zRoundBarDimensions.extend({ type: z.literal("round_bar") }),
      zRoundTubeDimensions.extend({ type: z.literal("round_tube") }),
      zRectangularTubeDimensions.extend({ type: z.literal("rectangular_tube") }),
    ])
    .nullish(),
});

/**
 * ToleranceType
 */
export const zToleranceType = z.enum(["numerical", "iso"]);

/**
 * PartTolerance
 */
export const zPartTolerance = z.object({
  type: zToleranceType,
  raw_value: z.string(),
  span: z.number().nullish(),
});

/**
 * PartAngleMeasure
 */
export const zPartAngleMeasure = z.object({
  tolerance: zPartTolerance.nullish(),
  type: z.literal("angle"),
  angle: z.number(),
});

/**
 * PartDiameterMeasure
 */
export const zPartDiameterMeasure = z.object({
  tolerance: zPartTolerance.nullish(),
  type: z.literal("diameter"),
  diameter: z.number(),
});

/**
 * PartLinearMeasure
 */
export const zPartLinearMeasure = z.object({
  tolerance: zPartTolerance.nullish(),
  type: z.literal("linear"),
  length: z.number(),
});

/**
 * PartRadiusMeasure
 */
export const zPartRadiusMeasure = z.object({
  tolerance: zPartTolerance.nullish(),
  type: z.literal("radius"),
  radius: z.number(),
});

/**
 * PartThreadingMeasure
 */
export const zPartThreadingMeasure = z.object({
  tolerance: zPartTolerance.nullish(),
  type: z.literal("threading"),
  diameter: z.number(),
});

/**
 * PartComplexity
 */
export const zPartComplexity = z.object({
  topo: zPartTopoComplexity.nullish(),
  roughnesses: z.array(zPartRoughness).nullish(),
  gdts: z.array(zPartGdt).nullish(),
  measures: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("linear"),
          })
          .and(zPartLinearMeasure),
        z
          .object({
            type: z.literal("diameter"),
          })
          .and(zPartDiameterMeasure),
        z
          .object({
            type: z.literal("radius"),
          })
          .and(zPartRadiusMeasure),
        z
          .object({
            type: z.literal("angle"),
          })
          .and(zPartAngleMeasure),
        z
          .object({
            type: z.literal("threading"),
          })
          .and(zPartThreadingMeasure),
      ]),
    )
    .nullish(),
});

/**
 * Part
 */
export const zPart = z.object({
  source: zSource,
  version: zPartVersion,
  metadata: zPartMetadata.nullish(),
  features: z
    .array(
      z.union([
        z
          .object({
            type: z.literal("Hole"),
          })
          .and(zHoleFeatures),
        z
          .object({
            type: z.literal("Folding"),
          })
          .and(zFoldFeatures),
        z
          .object({
            type: z.literal("Side"),
          })
          .and(zSideFeatures),
        z
          .object({
            type: z.literal("Interactions"),
          })
          .and(zInteractionsFeatures),
        z
          .object({
            type: z.literal("Machining"),
          })
          .and(zMachiningFeatures),
      ]),
    )
    .nullish(),
  dimensions: zPartDimensions.nullish(),
  complexity: zPartComplexity.nullish(),
  representations: zPartRepresentation.nullish(),
});

/**
 * PredictFromDrawingRequest
 */
export const zPredictFromDrawingRequest = z.object({
  part_json: zPart.nullish(),
  part_level: zPartLevel.nullish(),
  drawing_extraction: zDrawingExtractionModel.optional(),
  model_key: z.string().optional().default(""),
  model_alias: zModelAlias.optional().default("prod"),
  process_keys: z
    .union([z.string(), z.array(z.string())])
    .nullish()
    .default("all"),
  drawing_embedding: z.array(z.number()).nullish(),
  feature_json: z.array(z.record(z.unknown())).nullish(),
});

/**
 * PredictMultiModalRequest
 */
export const zPredictMultiModalRequest = z.object({
  model_key: z.string().optional().default(""),
  user_input: zMultiModalUserInput,
  part_level: zPartLevel.nullish(),
  part_json_2d: zPart.nullish(),
  part_json_3d: zPart.nullish(),
  process_keys: z
    .union([z.string(), z.array(z.string())])
    .nullish()
    .default("all"),
  graph_url: z.string().url().min(1).nullish(),
  graph: z.record(z.unknown()).nullish().default({}),
});

/**
 * PredictV2Request
 */
export const zPredictV2Request = z.object({
  part_json: zPart.nullish(),
  material: z.string().optional().default("STEEL"),
  process_keys: z
    .union([z.string(), z.array(z.string())])
    .nullish()
    .default("all"),
  additional_process_names: z.array(z.string()).nullish(),
  model_key: z.string().optional().default(""),
  model_alias: zModelAlias.optional().default("prod"),
  custom_inputs: z.array(z.record(z.unknown())).optional().default([]),
  cnc_duration_from_graph: z.boolean().optional().default(true),
  cnc_raw_dimensions: z
    .union([
      z.record(z.unknown()),
      z.tuple([z.number(), z.number()]),
      z.tuple([z.number(), z.number(), z.number()]),
      zSolidRoundBar,
      zHollowTube,
      zSolidSquareBar,
      zHollowSquareBar,
    ])
    .nullish(),
  feature_json: z.array(z.record(z.unknown())).nullish(),
  alert_time_per_fold_in_sec_min: z.number().optional().default(3),
  alert_time_per_fold_in_sec_max: z.number().optional().default(45),
  alert_cut_time_per_mm_in_sec_min: z.number().optional().default(0.009),
  alert_cut_time_per_mm_in_sec_max: z.number().optional().default(0.1),
  alert_milling_n_intercept: z.number().optional().default(0.3),
  alert_turning_n_intercept: z.number().optional().default(0.3),
  graph_url: z.string().url().min(1).nullish(),
  graph: z.record(z.unknown()).nullish().default({}),
  part_type: zPartType.nullish(),
  part_level: zPartLevel.nullish(),
});

/**
 * ValidationError
 */
export const zValidationError = z.object({
  loc: z.array(z.union([z.string(), z.number().int()])),
  msg: z.string(),
  type: z.string(),
});

/**
 * HTTPValidationError
 */
export const zHttpValidationError = z.object({
  detail: z.array(zValidationError).optional(),
});

/**
 * Successful Response
 */
export const zHealthHealthGetResponse = zHealthResponse;

export const zPredictV2PredictV2PostBody = zPredictV2Request;

/**
 * Successful Response
 */
export const zPredictV2PredictV2PostResponse = zPredictedProcessStepsResponse;

export const zPredictMultiModalPredictMultiModalPostBody = zPredictMultiModalRequest;

/**
 * Successful Response
 */
export const zPredictMultiModalPredictMultiModalPostResponse = zPredictedProcessStepsResponse;

/**
 * Request
 */
export const zPredictV2BatchPredictV2BatchPostBody = z.array(zPredictV2Request);

/**
 * Response Predict V2 Batch Predict V2 Batch Post
 *
 * Successful Response
 */
export const zPredictV2BatchPredictV2BatchPostResponse = z.array(zPredictedProcessStepsResponse);

export const zPredictFromDrawingPredictFromDrawingPostBody = zPredictFromDrawingRequest;

/**
 * Successful Response
 */
export const zPredictFromDrawingPredictFromDrawingPostResponse = zPredictedProcessStepsResponse;

export const zGetAvailableMultiModalModelVersionMultiModalModelVersionsGetQuery = z.object({
  model_key: z.string(),
});

/**
 * Response Get Available Multi Modal Model Version Multi Modal Model Versions Get
 *
 * Successful Response
 */
export const zGetAvailableMultiModalModelVersionMultiModalModelVersionsGetResponse = z.array(
  z.string(),
);

export const zGetMultiModalModelCardMultiModalModelCardGetQuery = z.object({
  model_key: z.string(),
  version: z.string().optional().default("prod"),
});

/**
 * Response Get Multi Modal Model Card Multi Modal Model Card Get
 *
 * Successful Response
 */
export const zGetMultiModalModelCardMultiModalModelCardGetResponse = z
  .string()
  .url()
  .min(1)
  .nullable();

export const zGetModelVersionModelVersionGetQuery = z.object({
  model_key: z.string().optional().default(""),
  is_multi_modal: z.boolean().optional().default(false),
  model_alias: zModelAlias.optional().default("prod"),
});

/**
 * Successful Response
 */
export const zGetModelVersionModelVersionGetResponse = zModelVersionResponse;

export const zGetModelVersionRegistryModelVersionRegistryGetQuery = z.object({
  model_key: z.string().optional().default(""),
  is_multi_modal: z.boolean().optional().default(false),
  model_alias: zModelAlias.optional().default("prod"),
});

/**
 * Successful Response
 */
export const zGetModelVersionRegistryModelVersionRegistryGetResponse = zModelVersionResponse;

export const zGetModelDescriptionModelDescriptionGetQuery = z.object({
  model_key: z.string().optional().default(""),
  is_multi_modal: z.boolean().optional().default(false),
  model_alias: zModelAlias.optional().default("prod"),
});

/**
 * Successful Response
 */
export const zGetModelDescriptionModelDescriptionGetResponse = zPredictedProcessStepsResponse;

/**
 * Response Update Model Weights Update Model Weights Post
 *
 * Successful Response
 */
export const zUpdateModelWeightsUpdateModelWeightsPostResponse = z.record(z.unknown());

export const zCustomInputsCustomInputsPostBody = zCustomInputsRequest;

/**
 * Response Custom Inputs Custom Inputs Post
 *
 * Successful Response
 */
export const zCustomInputsCustomInputsPostResponse = z.array(
  z.union([
    z
      .object({
        type: z.literal("number"),
      })
      .and(zCustomInputNumber),
    z
      .object({
        type: z.literal("select"),
      })
      .and(zCustomInputSelect),
  ]),
);
